type CalculatedDetails =
  | { isNA: true }
  | {
      calculations: Array<{
        name: string;
        value: number;
        operation: 'add' | 'subtract';
      }>;
    };

export const prepareScratcherCountsDetails = (
  posScratcherQuantity: number,
  totalSold: number,
  variance: number | undefined,
  isPosZero: boolean,
  isLottoZero: boolean,
  hasPosType: boolean,
  showDiscrepancy: boolean = true,
): CalculatedDetails => {
  if (!showDiscrepancy) {
    return { isNA: true };
  }

  if (!hasPosType) {
    return { isNA: true };
  }

  if (
    posScratcherQuantity === 0 &&
    totalSold === 0 &&
    (variance === 0 || variance === undefined || variance === null) &&
    isPosZero &&
    isLottoZero
  ) {
    return { isNA: true };
  }

  return {
    calculations: [
      { name: 'POS reported quantity', value: posScratcherQuantity, operation: 'add' },
      { name: 'Audit total sold', value: totalSold, operation: 'subtract' },
    ],
  };
};

export const prepareScratcherSalesDetails = (
  posScratcherSales: number,
  revenue: number,
  variance: number | undefined,
  isPosZero: boolean,
  isLottoZero: boolean,
  hasPosType: boolean,
  showDiscrepancy: boolean = true,
): CalculatedDetails => {
  if (!showDiscrepancy) {
    return { isNA: true };
  }

  if (!hasPosType) {
    return { isNA: true };
  }

  if (
    posScratcherSales === 0 &&
    revenue === 0 &&
    (variance === 0 || variance === undefined || variance === null) &&
    isPosZero &&
    isLottoZero
  ) {
    return { isNA: true };
  }

  return {
    calculations: [
      { name: 'POS reported sales', value: posScratcherSales, operation: 'add' },
      { name: 'Audit revenue', value: revenue, operation: 'subtract' },
    ],
  };
};

export const prepareLottoSalesDetails = (
  posLottoSales: number,
  lottoSales: number,
  variance: number | undefined,
  isPosZero: boolean,
  isLottoZero: boolean,
  hasPosType: boolean,
  showDiscrepancy: boolean = true,
): CalculatedDetails => {
  if (!showDiscrepancy) {
    return { isNA: true };
  }

  if (!hasPosType) {
    return { isNA: true };
  }

  if (
    posLottoSales === 0 &&
    lottoSales === 0 &&
    (variance === 0 || variance === undefined || variance === null) &&
    isPosZero &&
    isLottoZero
  ) {
    return { isNA: true };
  }

  return {
    calculations: [
      { name: 'POS reported lotto sales', value: posLottoSales, operation: 'add' },
      { name: 'Lotto system sales', value: lottoSales, operation: 'subtract' },
    ],
  };
};

export const preparePayoutDetails = (
  lottoPayoutsTotal: number,
  freeTicketsAmount: number,
  posPayout: number,
  variance: number | undefined,
  isPosZero: boolean,
  isLottoZero: boolean,
  hasPosType: boolean,
  showDiscrepancy: boolean = true,
): CalculatedDetails => {
  if (!showDiscrepancy) {
    return { isNA: true };
  }

  if (!hasPosType) {
    return { isNA: true };
  }

  if (
    lottoPayoutsTotal === 0 &&
    freeTicketsAmount === 0 &&
    posPayout === 0 &&
    (variance === 0 || variance === undefined || variance === null) &&
    isPosZero &&
    isLottoZero
  ) {
    return { isNA: true };
  }

  return {
    calculations: [
      { name: 'Payouts (lottery system)', value: lottoPayoutsTotal, operation: 'add' },
      { name: 'Free tickets paid', value: freeTicketsAmount, operation: 'add' },
      { name: 'POS reported payout', value: posPayout, operation: 'subtract' },
    ],
  };
};

